.documents {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.uploadedFile {
    max-width: 300px;
}
